import React from "react";
import { Link } from "react-router-dom";

export default class Service extends React.Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="services-three">
          <div className="shape1">
            <img
              src={publicUrl + "assets/images/shapes/services-v3-shape1.png"}
              alt="#"
            />
          </div>
          <div className="shape2 rotate-me">
            <img
              src={publicUrl + "assets/images/update1.0/services-v3-shape2.png"}
              alt="#"
            />
          </div>
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="services-three__top">
                  <div className="sec-title">
                    <div className="sec-title__tagline">
                      <h6>NAŠE USLUGE </h6> <span className="right"></span>
                    </div>
                    <h2 className="sec-title__title">
                      Vrhunske usluge <br />u gradnji i adaptaciji
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {/* Start Services One Single */}
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="services-three__single">
                  <div
                    className="services-three__single__bg"
                    style={{
                      backgroundImage:
                        "url(" +
                        publicUrl +
                        "assets/images/services/services-v1-bg.jpg)",
                    }}
                  ></div>
                  <div className="services-three__single-icon">
                    <span className="icon-crane"></span>
                  </div>
                  <h3>
                    <Link to={process.env.PUBLIC_URL + `/general-contracting`}>
                      Gradnja poslovnih i stambenih objekata od temelja do krova
                      po sistemu “Ključ u ruke”
                    </Link>
                  </h3>
                  <p>
                    Izgradnja objekta je složen proces koji zahtijeva stručnost
                    i preciznu organizaciju. Naš tim vodi cijeli projekat do
                    faze opremanja, obezbjeđujući svu neophodnu mehanizaciju,
                    građevinske materijale i zanatske radove. Kontrolišemo svaki
                    korak izgradnje kako bismo osigurali kvalitet, efikasnost i
                    poštovanje dogovorenih rokova.
                    <br />
                    <br />
                  </p>
                  <div className="btn-box">
                    <Link to={process.env.PUBLIC_URL + `/general-contracting`}>
                      <span className="icon-right-arrow"></span>
                    </Link>
                  </div>
                </div>
              </div>
              {/* End Services One Single */}

              {/* Start Services One Single */}
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="services-three__single">
                  <div
                    className="services-three__single__bg"
                    style={{
                      backgroundImage:
                        "url(" +
                        publicUrl +
                        "assets/images/services/services-v1-bg.jpg)",
                    }}
                  ></div>
                  <div className="services-three__single-icon">
                    <span className="icon-interior-design-1"></span>
                  </div>
                  <h3>
                    <Link to={process.env.PUBLIC_URL + `/general-contracting`}>
                      Renoviranje poslovnih i stambenih objekata + 3D dizajn
                    </Link>
                  </h3>
                  <p>
                    Renoviranje objekta zahtijeva preciznu koordinaciju velikog
                    broja zanatskih radova, isporuku stolarije, sanitarija i
                    završnih materijala. Naš tim preuzima kompletnu
                    organizaciju, osiguravajući da se svi radovi odvijaju po
                    planu i budu završeni u dogovorenom roku, bez nepotrebnih
                    kašnjenja. Po želji klijenta, nudimo i izradu detaljnog 3D
                    dizajna, kako bismo omogućili jasan uvid u završni izgled
                    prostora prije početka radova.
                  </p>
                  <div className="btn-box">
                    <Link to={process.env.PUBLIC_URL + `/general-contracting`}>
                      <span className="icon-right-arrow"></span>
                    </Link>
                  </div>
                </div>
              </div>
              {/* End Services One Single */}

              {/* Start Services One Single */}
              {/* <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="services-three__single">
                  <div
                    className="services-three__single__bg"
                    style={{
                      backgroundImage:
                        "url(" +
                        publicUrl +
                        "assets/images/services/services-v1-bg.jpg)",
                    }}
                  ></div>
                  <div className="services-three__single-icon">
                    <span className="icon-surgery"></span>
                  </div>
                  <h3>
                    <Link to={process.env.PUBLIC_URL + `/general-contracting`}>
                      Moleraj
                    </Link>
                  </h3>
                  <p>
                    Molerskim radovima možete brzo i dramatično da
                    transformišete izgled sobe, stana ili poslovnog prostora,
                    koje je ujedno najjednostavniji i najjeftiniji način da
                    izmjenite izgled prostora.
                    <br />
                    <br />
                    <br />
                  </p>
                  <div className="btn-box">
                    <Link to={process.env.PUBLIC_URL + `/general-contracting`}>
                      <span className="icon-right-arrow"></span>
                    </Link>
                  </div>
                </div>
              </div> */}
              {/* End Services One Single */}
            </div>
          </div>
        </section>
      </>
    );
  }
}
